import { render, staticRenderFns } from "./DialogBusinessPlanQuickTour.vue?vue&type=template&id=c23d7146"
import script from "./DialogBusinessPlanQuickTour.vue?vue&type=script&lang=js"
export * from "./DialogBusinessPlanQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23d7146')) {
      api.createRecord('c23d7146', component.options)
    } else {
      api.reload('c23d7146', component.options)
    }
    module.hot.accept("./DialogBusinessPlanQuickTour.vue?vue&type=template&id=c23d7146", function () {
      api.rerender('c23d7146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/Components/Dialogs/DialogBusinessPlanQuickTour.vue"
export default component.exports